import styled from "styled-components"

export interface StyledLoaderProps {
}
export interface StyledLoaderInputProps {
  input_height: string
}

export const StyledLoader = styled.div<StyledLoaderProps>`
`
export const StyledLoaderCopy = styled.div`
  position: absolute;
  opacity: 0;
  z-index: -1000000;
  left: -99999999px;
  top: -99999999px;
`
export const StyledLoaderList = styled.div<StyledLoaderProps>`
  display: flex;
  flex-wrap: wrap;
`
export const StyledLoaderInput = styled.div<StyledLoaderInputProps>`
  height: ${props => props.input_height}px;
  background: rgba(0,0,0,0.05);
  width: 100%;
  border-radius: 4px;
  margin: 16px 0 0;
  position: relative;
  overflow: hidden;

  &:nth-of-type(1){
    margin-top: 0;
  }
  &:nth-of-type(2), &:nth-of-type(3){
    width: calc(50% - 4px);
  }
  &:nth-of-type(5){
    width: calc(25% - 4px);
  }
  &:nth-of-type(6){
    width: calc(75% - 4px);
  }
  &:nth-of-type(3), &:nth-of-type(6){
    margin-left: 8px;
  }

  &:after{
    content: "";
    z-index:1;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255, .7) 50%, transparent 100%);
    height: 100%;
    width: 50%;
    animation: animateLoad 1s infinite;
  }



  @keyframes animateLoad {
    0% {
      left:-50%;
    }
    100% {
      left: 100%;
    }
  }
`